<span
  [rtTooltip]="
    isDisabled ? ('app.requisitions.flow.change_flow_disabled_tooltip' | translate) : null
  "
  [rtTooltipMaxWidth]="240"
  [rtTooltipHasTextAlignCenter]="true"
>
  <rt-button
    variant="outline"
    [disabled]="isDisabled"
    [dropdownOpened]="flowsDropdown.open"
    [class.has-value]="!!selectedOption"
    (click)="flowsDropdown.open = !flowsDropdown.open"
    rt-overlay-origin
    #flowsDropdownTrigger="rtOverlayOrigin"
  >
    <rt-icon [name]="selectedOption ? 'playlist-add-check' : 'checklist'" />
    {{ selectedOption?.label || ('app.requisitions.flow.select_flow' | translate) }}
  </rt-button>
</span>

<ng-template
  rt-connected-overlay
  #flowsDropdown="rtConnectedOverlay"
  [origin]="flowsDropdownTrigger"
  [hasBackdrop]="true"
  (backdropClick)="flowsDropdown.open = false"
>
  <rt-dropdown (click)="$event.preventDefault()">
    <rt-dropdown-header>
      {{ 'app.requisitions.flow.change_flow' | translate }}
    </rt-dropdown-header>
    @if (hasSearch) {
      <rt-form-field
        (click)="$event.preventDefault()"
        variant="search underlined"
        margin-lr-small
        margin-tb-small-x
      >
        <rt-input
          [value]="searchControl.value"
          [autoFocus]="true"
          [hasClearButton]="true"
          (valueChange)="searchControl.patchValue($event)"
          variant="underlined"
          [placeholder]="'app.requisitions.flow.search_flows' | translate"
        >
          <rt-icon prefix name="search" />
        </rt-input>
      </rt-form-field>
    }

    <div class="has-scroll-y" style="max-height: 275px">
      @for (option of visibleOptions; track trackByValue($index, option)) {
        <rt-dropdown-item (click)="select.emit(option); flowsDropdown.open = false">{{
          option.label
        }}</rt-dropdown-item>
      }
    </div>
    @if (visibleOptions.length === 0) {
      <rt-dropdown-item [hasHoverEffect]="false">
        {{ 'app.common.no_results_found' | translate }}
      </rt-dropdown-item>
    }
  </rt-dropdown>
</ng-template>
